export { attachmentVariables as attachmentIconVariables } from './attachmentVariables';
